
import Vue from 'vue';
export default Vue.extend({
  name: 'App',
  created() {
    // 在App创建生命周期，执行相应的全局数据获取与同步
  },
});
